import type { Journey } from '@/data/schema/journey'

export function isComplete(journey: Journey) {
	return journey.complete ?? false
}

export const deliveryQuestions = [
	'Reason for skipping survey?',
	'Was your order delivered on time, in full?',
	"How confident are you in Mabey's ability to deliver next time?",
	'How likely are you to recommend Mabey Hire after your delivery experience?',
	"Any final comments / things you'd like to discuss further / member of staff you'd like to highlight?",
	'Customer name'
]

export const collectionQuestions = [
	'Reason for skipping survey?',
	'Was your collection completed on time?',
	"How confident are you in Mabey's ability to collect next time",
	'How likely are you to recommend Mabey Hire after your collection experience?',
	"Any final comments / things you'd like to discuss further / member of staff you'd like to highlight?",
	'Customer name'
]
